import type { StockState } from '../api/dto';

export const STOCK_STATE_LABEL: Record<StockState, string> = {
  available: 'Disponible',
  reserved: 'Reserve',
  damaged: 'Endommage',
  lost: 'Perdu',
  sold: 'Vendu',
  corrected: 'Corrige',
  recycled: 'Recycle',
  produced: 'Produit',
};

export const MOVEMENT_LABEL: Record<string, string> = {
  in: 'Entree',
  out: 'Sortie',
  move: 'Transfert',
  replace: 'Remplacement',
  adjust: 'Ajustement',
  reserve: 'Reservation',
  release: 'Liberation',
  'write-off': 'Depreciation',
};
